import { Padding } from 'components/base/layout-components';
import styled from 'styled-components';

export const StyledContainer = styled(Padding)`
  overflow: auto;
`;
